import { Report, TSessionSummaryReport } from "../../types/types";
import { api } from "./api";
import { TMeetingRecord, TGetUserMeetingRecordsResponse } from "../types/sessionSummary.types";
import i18next from "i18next";

export const sessionSummaryApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSessionSummaryReport: build.query<
      TSessionSummaryReport,
      { userGuid: string; language: string }
    >({
      query: ({ userGuid, language }) => ({
        url: `AI_Meeting/AI_GenerateSessionSummaryReport/${userGuid}/${language}`,
        method: "GET",
      }),
      // providesTags: ['sessionSummary'],

      // For testing purposes - return mock data instead of making API call
      // Uncomment the queryFn below and comment out the query above to use test data
      /*
      queryFn: () => {
        return {
          data: {
            "language": "he",
            "bprevenLogoUrl": "logo.png",
            "companyLogoUrl": "https://localhost:5002/Uploads/0/6/Makshivim.png",
            "reportDate": "2023-10-01T00:00:00",
            "therapistName": "בדיקה סופר אדמין",
            "therapistId": 0,
            "reportsIncludedInSummary": "הסיכום נוצר על בסיס 2 דוחות מתוך 2",
            "patientFirstName": "sus",
            "patientLastName": "",
            "patientIdNumber": 1048,
            "referralReasons": "נושאים יומיומיים: שיחת תמיכה",
            "lifeHistory": "לא צוין",
            "mentalStatusAtIntake": "חרדה: נמוך, דיכאון: נמוך, חוסן: בינוני",
            "functioningAtIntake": "לא צוין",
            "isDangerObserved": true,
            "isAddictionObserved": false,
            "preliminaryDiagnosisICD10_DSM5": "לא צוין",
            "treatmentPlanAndGoals_AsDeterminedAtIntake_TreatmentFrequency_TherapeuticGoals_OtherNotes": "לא צוין",
            "treatmentCourseDescription_NumberOfSessionsThemesEngagedResponse": "משך זמן טיפול: 45 דקות, אופן הטיפול: וידאו",
            "currentMentalStatusAppearanceBehaviorCooperationMoodAffectPerceptionThinkingProcessAndPace": "לא צוין",
            "currentFunctioning": "לא צוין",
            "therapeuticGoalsAchieved": "לא צוין",
            "currentWorkingDiagnosisAccordingTo_ICD10_DSM5": "לא צוין",
            "recommendationsIncludingTreatmentPlanAndUpdatedGoalsIfContinuedTreatmentIsAdvised": "לא צוין",
            "additionalRelevantInformationToAdd": "לא צוין",
            "therapistSignature": "לא צוין",
            "isDigitallySigned": false
          } as TSessionSummaryReport
        };
      },
      */
    }),
    getUserMeetingRecords: build.mutation<TGetUserMeetingRecordsResponse, string>({
      query: (userGuid) => ({
        url: `/Therapists/getAllRecording/${userGuid}`,
        method: "GET",
      }),
    }),
    exportMeetingSummaryToPdf: build.mutation<
      { success: boolean; pdfBase64?: string; fileName?: string; errorMessage?: string },
      { userGuid: string; recordNumber: number; language?: string }
    >({
      query: ({ userGuid, recordNumber, language = "he" }) => ({
        url: `/MeetingRecords/exportSummaryToPdf`,
        method: "POST",
        body: { usersGuid: userGuid, recordNumber, language },
      }),
    }),
    generateMeetingReport: build.mutation<
      Report,
      { body: TSessionSummaryReport; userGuid: string; }
    >({
      query: ({ body, userGuid }) => ({
        url: `/AI_Meeting/report/${userGuid}`,
        method: "POST",
        body: JSON.stringify(body),
      }),
    }),
  }),
});

export const {
  useGetSessionSummaryReportQuery,
  useGetUserMeetingRecordsMutation,
  useGenerateMeetingReportMutation,
  useExportMeetingSummaryToPdfMutation,
} = sessionSummaryApi;
